import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';
import { GLOBAL } from './global';
@Injectable()
export class VariableService{
  public login: boolean;
  /*public contract:boolean;
  public customer:boolean;
  public inventary:boolean;
  public service:boolean;
  public warehouse:boolean;
  public role:string;
  public userID:number;*/
  public levelAccess: any;
  public timeToLoad:number = 2000;
  public timeMessage:number = 2000;
  public timeToReport:number = 1500;
  public sessionTime:number = 2000;
  public ValueSession:any;
  public url:string;

  constructor(
    public _http: Http
  )
  {
    this.url = GLOBAL.url;
  }

  public validSession()
  {
    console.log("Username C",this.getCookie('username'));
    console.log("PAssword C",this.getCookie('password'));
    this.checksession(this.getCookie('user_id')).subscribe(
      response => {
        console.log("respuesta",response.data);
        if(response.code == 200)
        {

          if(response.data[0].UUID_code != '403')
          {
            this.login = true;
          }
          else
          {
            this.login = false;
          }
        }else
        {
         console.log("neel");
        }
      },
      error => {
        console.log(<any>error);
      }
  );
  }

  public getPrivileges()
  {

    return this._http.get(this.url+'getLevelAccess/'+this.getCookie('username')+'/'+this.getCookie('password')).map(res => res.json());
  }


  public checksession(id:any)
  {
    console.log("User id",this.getCookie('user_id'));
    return this._http.get(this.url+'checksession/'+id).map(res => res.json());
  }

  public getLevelAccess(username:string,password:string)
  {
    return this._http.get(this.url+'getLevelAccess/'+username+'/'+password).map(res => res.json());
  }

  public getCookie(cname) {
      var name = cname + "=";
      var decodedCookie = decodeURIComponent(document.cookie);
      var ca = decodedCookie.split(';');
      for(var i = 0; i <ca.length; i++) {
          var c = ca[i];
          while (c.charAt(0) == ' ') {
              c = c.substring(1);
          }
          if (c.indexOf(name) == 0) {
              return c.substring(name.length, c.length);
          }
      }
      return "";
    }

   public setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }
}



// WEBPACK FOOTER //
// /home/isai/funeraria/src/app/services/sharedVariables.ts